import { render, staticRenderFns } from "./document-preview.vue?vue&type=template&id=3811a85d&"
import script from "./document-preview.vue?vue&type=script&lang=js&"
export * from "./document-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports